import { useState } from 'react';
import { ReactNode } from 'react';

import Accordion from '@com/shared/motionAccordion';
import { colors } from '@configs/Theme';
import Icon from '@utilities/icon';

type HomeAccordionItemProps = {
  id: number;
  title: string;
  value: ReactNode;
};

const HomeAccordionItem = ({ id, title, value }: HomeAccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="w-full h-full min-h-[70px] flex px-5 gap-x-5 rounded-xs"
      onClick={() => setIsOpen(!isOpen)}
      tabIndex={id}
      role="button"
      onKeyDown={() => {
        return;
      }}
    >
      <div className="w-full h-full flex py-2 flex-col gap-y-2">
        <div className="text-md text-content-primary pt-3">{title}</div>
        <Accordion isOpen={isOpen}>
          <div className="text-md text-content-tertiary">{value}</div>
        </Accordion>
      </div>

      <Icon
        name={isOpen ? 'ChevronUp' : 'ChevronDown'}
        width={1.5}
        height={1.5}
        className="mt-[24px]"
        fill={colors?.gray[600]}
      />
    </div>
  );
};

export default HomeAccordionItem;
